import SDK from "@yxim/nim-web-sdk";

let fakeId = 1
export default {
  initializeNim ({ commit, state }, {
    onconnect,
    onWillReconnect,
    ondisconnect,
    onError,
    onfriends,
    onusers,
    onupdateuser,
    onsyncfriendaction,
    onsessions,
    onupdatesessions,
    onofflinemsgs,
    onroamingmsgs,
    onmsg,
    onMsgReceipts,
    onupdatemyinfo,
    onteams,
    onCreateTeam,
    shouldCountNotifyUnread,
    onRemoveTeamMembers,
    onsysmsgunread,
    onupdatesysmsgunread,
    oncustomsysmsg,
    onsyncdone
  }) {
    const nim = SDK.NIM.getInstance({
      debug: false,
      syncSessionUnread: true,
      syncMsgReceipts: true,
      appKey: '4a16c4a6e1ebca1b85848f4184f16231',
      account: state.imAccount.im_accid,
      token: state.imAccount.im_token,
      onconnect: onconnect,
      onwillreconnect: onWillReconnect,
      ondisconnect: ondisconnect,
      onerror: onError,
      onfriends: onfriends,
      onusers: onusers,
      onupdateuser: onupdateuser,
      onsyncfriendaction: onsyncfriendaction,
      onsessions: onsessions,
      onupdatesessions: onupdatesessions,
      onofflinemsgs: onofflinemsgs,
      onroamingmsgs: onroamingmsgs,
      onmsg: onmsg,
      onMsgReceipts: onMsgReceipts,
      onupdatemyinfo: onupdatemyinfo,
      onteams: onteams,
      onCreateTeam: onCreateTeam,
      shouldCountNotifyUnread: shouldCountNotifyUnread,
      onRemoveTeamMembers: onRemoveTeamMembers,
      onsysmsgunread: onsysmsgunread,
      onupdatesysmsgunread: onupdatesysmsgunread,
      oncustomsysmsg: oncustomsysmsg,
      onsyncdone: onsyncdone
    })
    commit('setNimInstance', nim)
  },
  async sendMessage ({ state, commit, dispatch }, { text }) {
    return new Promise((resolve, reject) => {
      if (!text) {
        reject('消息不能为空')
        return
      }

      const nim = state.nim
      const msg = nim.sendText({
        scene: state.imActiveAccount.scene,
        to: state.imActiveAccount.to,
        text: text,
        done: (error, data) => {
          if (error) {
            reject(error)
          } else {
            commit('imMsgListToBottomMutation', true)
            dispatch('updateMsgInMsgArr', data)
            resolve(data)
          }
        }
      })
      dispatch('addMsgToMsgArr', msg)
    })
  },
  fetchUserInfo ({ state, commit }, account) {
    const nim = state.nim
    nim.getUser({
      account,
      sync: true,
      done: (err, user) => {
        if (err) {
          console.error('获取用户信息失败', err)
        } else {
          commit('addImUserProfilesMutation', user)
        }
      }
    })
  },
  deleteLocalSession ({ state, commit }, sessionId) {
    const nim = state.nim

    nim.deleteLocalSession({
      id: sessionId,
      isLogic: false,
      done: function (err, data) {
        console.log('删除本地会话', err, data)
        if (err) {
          console.log('删除本地会话失败')
        }
      }
    })
  },
  deleteSession ({ state, commit }, session) {
    const { scene, to, id } = session
    const nim = state.nim

    nim.clearServerHistoryMsgsWithSync({
      isDeleteRoam: true,
      isSyncSelf: false,
      scene: scene,
      to: to,
      done: function (err, data) {
        if (err) {
          console.error('从服务端删除漫游消息失败')
        } else {
          nim.deleteLocalSession({
            id: id,
            isLogic: false,
            done: function (err, data) {
              if (err) {
                console.log('删除本地会话失败')
              }
            }
          })
        }
      }
    })
  },
  addSession ({ state, commit }, { account, scene }) {
    const sessionId = `${scene}-${account}`
    if (!state.imSessionMap[sessionId]) {
      let session = {
        id: sessionId,
        scene: scene,
        to: account,
        unread: 0,
        updateTime: Date.now(),
        lastMsg: null
      }
      commit('setImSessionMapMutation', session)
      state.imSessions.unshift(session)
    } else {
      let session = state.imSessionMap[sessionId]
      session.updateTime = Date.now()
      commit('setImSessionMapMutation', session)
      // Vue.set(state.imSessionMap[sessionId], 'updateTime', Date.now())
      console.log('state.imSessionMap[sessionId]', state.imSessionMap[sessionId])
    }

    state.imLeftActiveName = 'chat'
    state.imActiveAccount = state.imSessionMap[sessionId]
  },
  addMsgToMsgArr ({ state, commit }, msg) {
    console.log('1111')
    const sessionId = msg.sessionId
    state.imSessionMsgs[sessionId] = state.imSessionMsgs[sessionId] || {
      msgArr: [],
      fetching: false,
      complete: false
    }
    const sessionMsg = state.imSessionMsgs[sessionId]
    sessionMsg.msgArr.push(msg)
    commit('setImSessionMsgMutation', { sessionId, sessionMsg })
    // const msgArr = state.imSessionMsgs[sessionId].msgArr
    // msgArr.push(msg)
    // state.imSessionMsgs[sessionId].msgArr.push(msg)
    // state.imSessionMsgs = {...state.imSessionMsgs}
    if (!state.imMessages.some(item => item.idClient === msg.idClient) && msg.sessionId === state.imActiveAccount.id && msg.scene !== 'team') {
      state.imMessages.push(msg)
    }
  },
  updateMsgInMsgArr ({ state, commit }, msg) {
    const sessionId = msg.sessionId
    if (state.imSessionMsgs[sessionId]) {
      const msgArr = state.imSessionMsgs[sessionId].msgArr
      for (let i = 0; i < msgArr.length; i++) {
        if (msgArr[i].idClient === msg.idClient) {
          msgArr[i] = msg
          break
        }
      }
    }
  },
  loadMoreMsgOfSession ({ state, commit, dispatch }, { scene, to, limit, messageListScrollTot }) {
    if (to === '7380252502656237619') {
      commit('setImMessageMutation', [])
      return
    }

    const sessionId = `${scene}-${to}`
    console.log('sessionId', sessionId)
    const sessionMsg = state.imSessionMsgs[sessionId] || {
      msgArr: [],
      fetching: false,
      complete: false
    }
    // commit('setImSessionMsgMutation', { sessionId, sessionMsg: state.imSessionMsgs[sessionId] })

    commit('setImSessionMsgMutation', { sessionId, sessionMsg })

    if (state.imSessionMsgs[sessionId].complete) {
      commit('setImMessageMutation', state.imSessionMsgs[sessionId].msgArr)
      if (messageListScrollTot === 'bottom') commit('imMsgListToBottomMutation', true)
      return
    }


    const msgArr = state.imSessionMsgs[sessionId].msgArr
    console.log('state imSessionMsgs-', state.imSessionMsgs[sessionId])
    console.log('msgArr', msgArr)
    const lastMsg = msgArr[0]

    if (scene === 'team' && state.imTeams[to] && state.imTeams[to].validToCurrentUser === false) {
      console.log('teamteamteam',state.imSessionMsgs[sessionId])
      if (!lastMsg) dispatch('addMsgToMsgArr', state.imSessionMap[sessionId].lastMsg)
      commit('setImMessageMutation', state.imSessionMsgs[sessionId].msgArr)
      if (messageListScrollTot === 'bottom') commit('imMsgListToBottomMutation', true)
      return
    }
    console.log('teamteamteam  fff', state.imSessionMsgs[sessionId])

    const params = {
      asc: false,
      scene: scene,
      to: to,
      beginTime: 0,
      limit: limit,
      endTime: lastMsg ? lastMsg.time : 0,
      // 从endTime开始往前查询
      reverse: false,
      done: (err, data) => {
        // 结束调用，设置fetching = false
        commit('updateFetchingMutation', { sessionId, fetching: false })


        if (err) {
          console.log('loadMoreMsgOfSession Error：', err)
        } else if (data && data.msgs && data.msgs.length > 0) {
          msgArr.unshift(...data.msgs.reverse())
          commit('updateMsgArrMutation', { sessionId, msgArr })
          if (messageListScrollTot === 'top') {
            commit('imMsgListToTopMutation', data.msgs.length * 105)
          }

          console.log('data.msgs', data.msgs)
          // 拉取的消息长度 < 分页长度，因此 complete = true
          if (data.msgs.length < limit) {
            commit('updateCompleteMutation', { sessionId, complete: true })
          }
        } else {
          commit('updateCompleteMutation', { sessionId, complete: true })
        }
        commit('setImMessageMutation', state.imSessionMsgs[sessionId].msgArr)
        if (messageListScrollTot === 'bottom') commit('imMsgListToBottomMutation', true)
        if (messageListScrollTot === 'top') dispatch('markMsgReceived', state.imSessionMap[sessionId])
        console.log(`当前会话: ${sessionId} 的历史消息为`, state.imSessionMsgs[sessionId])
      }
    }

    if (lastMsg) {
      params.lasntMsgId = lastMsg.idServer
    }

    commit('updateFetchingMutation', { sessionId, fetching: true })
    const nim = state.nim
    nim.getHistoryMsgs(params)
  },
  // 发送已读回执
  msgReceiptSend ({ state, commit }, lastMsg) {
    console.log('lastMsg', lastMsg)
    const nim = state.nim
    nim.sendMsgReceipt({
      msg: lastMsg,
      done: (error, obj) => {
        console.log('发送消息已读回执' + (!error?'成功':'失败'), error, obj);
      }
    })
  },
  // 标记消息已读状态
  markMsgReceived ({ state, commit }, session) {
    const sessionId = session.id
    const sessionMsgReceiptTime = session.msgReceiptTime
    if (state.imSessionMsgs[sessionId] && sessionMsgReceiptTime) {
      const sessionMsgArr = state.imSessionMsgs[sessionId]
      setTimeout(() => {
        for (let i = 0; i < sessionMsgArr.msgArr.length; i++) {
          const msg = sessionMsgArr.msgArr[i]
          if (msg.from === state.imAccount.im_accid && msg.to !== state.imAccount.im_accid) {
            if (msg.readByOtherUser) {
              /**
               * 如果 A 消息标记了已读回执，则A 消息之前的所有消息也标记了已读回执
               * 因此，碰到第一条已读回执的消息，就可以终止循环，因为后面的消息都是已读回执的消息
               */
              // if (state.imMessages[i] && (!state.imMessages[i].readByOtherUser)) {
              //   state.imMessages[i].readByOtherUser = true
              //   state.imMessages = [...state.imMessages]
              // }
            } else if (msg.time > sessionMsgReceiptTime) {
              // 消息时间晚于已读时间
            } else {
              // 消息时间早于等于已读回执时间
              msg.readByOtherUser = true
              state.imSessionMsgs[sessionId].msgArr[i].readByOtherUser = true
              state.imSessionMsgs = {...state.imSessionMsgs}
              if (state.imMessages[i]) {
                state.imMessages[i].readByOtherUser = true
                state.imMessages = [...state.imMessages]
              }
            }
          }
        }
      }, 500)
    }
  },
  // 进入会话的界面后，调用该函数，设置会话的未读数为0。同时，如果有新消息到来的话，会话未读数会保持为0
  setCurrSession ({ state, commit }, session) {
    if (session.id === '7380252502656237619') return
    const nim = state.nim
    nim.setCurrSession(session.id)
  },
  // 退出会话后，调用该接口取消设置当前会话。这样，有新消息到来时，会话未读数会更新
  resetCurrSession ({ state, commit }, session) {
    console.log('resetCurrSession', session.id)
    if (!session.id) return
    if (session.id === '7380252502656237619') return
    const nim = state.nim
    nim.resetCurrSession(session.id)
  },
  // 切换会话对象
  imActiveChange ({ state, commit, dispatch }, { session, scene, to, messageListScrollTot, imAccId }) {
    console.log('session', session, scene, to, messageListScrollTot, imAccId)
    let limit = 10
    dispatch('loadMoreMsgOfSession', { scene, to, limit, messageListScrollTot })
    if (session.lastMsg && session.lastMsg.scene === 'p2p' && (session.lastMsg.from !== imAccId) && (session.id !== '7380252502656237619')) {
      dispatch('msgReceiptSend', session.lastMsg)
    }
    dispatch('setCurrSession', session)
  },
 sendFile ({ state, commit, dispatch }, { domId, blobUrl, type, name, size, done }) {
    const fakeFileMessage = {
      idClient: `fake-file-${fakeId++}`
    }
    const nim = state.nim

    // 创建 fileMsg 对象，初始化 payload

    const fileMsg = nim.sendFile({
      scene: state.imActiveAccount.scene,
      to: state.imActiveAccount.to,
      type: type,
      fileInput: domId,
      beforesend: (msg) => {
        console.log('正在发送文件消息', msg)
        // dispatch('addMsgToMsgArr', msg)
      },
      uploadprogress: (data) => {
        console.log('上传进度: ' + data.percentage);
        fileMsg.payload = {
          progress: data.percentage,
          uploadDone: false,
          url: blobUrl,
          name: name,
          size: size
        }
      },
      uploaddone: (error, file) => {
        console.log('uploaddone', file)
        console.log('上传' + (!error?'成功':'失败'))
        if (!error) {
          fileMsg.payload = {
            progress: 100,
            uploadDone: true,
            url: blobUrl,
            name: name,
            size: size
          }
        }
      },
      done: done
    })

   fileMsg.payload = {
     progress: 0,
     uploadDone: false,
     url: blobUrl,
     name: name,
     size: size
   }
   dispatch('addMsgToMsgArr', fileMsg)
   commit('imMsgListToBottomMutation', true)

  },
  sendCustomSysMsg ({state, commit}, content) {
    const nim = state.nim
    let msgId = nim.sendCustomSysMsg({
      scene: 'p2p',
      to: state.imAccount.im_accid,
      content: JSON.stringify(content),
      sendToOnlineUsersOnly: false,
      done: (error, msg) => {
        console.log(error)
        console.log(msg)
        console.log('发送' + msg.scene + '自定义系统通知' + (!error?'成功':'失败') + ', id=' + msg.idClient)
      }
    })
    console.log('正在发送p2p自定义系统通知, id=' + msgId);
  },
  // 创建群
  createTeam ({state, commit}, teamInfo) {
    const nim = state.nim
    nim.createTeam({
      type: 'advanced', // 高级群
      name: teamInfo.name,
      accounts: teamInfo.accounts, // 群成员账号
      intro: teamInfo.intro, // 群简介
      announcement: teamInfo.announcement, // 群公告
      ps: teamInfo.ps,
      joinMode: 'noVerify', // 加入群不需要验证
      beInviteMode: 'noVerify', // 邀请入群不需要验证
      done: (error, obj) => {
        console.log('创建' + obj.team.type + '群' + (!error?'成功':'失败'), error, obj)
        if (!error) {
          // nim.onCreateTeam(obj.team, obj.owner)
          if (state.imLeftActiveName !== 'chat') state.imLeftActiveName = 'chat'
          // const sessionId = `team-${obj.team.teamId}`
          // state.imActiveAccount = state.imSessionMap[sessionId]
        }
      }
    })
  },
  // 更新群信息
  updateTeam ({state, commit}, { teamInfo, custom }) {
    const nim = state.nim
    nim.updateTeam({
      teamId: teamInfo.teamId,
      name: teamInfo.name,
      avatar: teamInfo.avatar,
      intro: teamInfo.intro,
      announcement: teamInfo.announcement,
      custom: custom,
      done: (error, team) => {
        console.log('更新群' + (!error?'成功':'失败'), error, team)
      }
    })
  },
  // 获取群会话对应的 team 信息
  fetchTeamInfo ({state, commit}, teamId) {
    const nim = state.nim
    nim.getTeam({
      teamId,
      sync: true,
      done: (err, team) => {
        if (err) {
          console.error('获取群信息失败', err)
        } else {
          commit('addImTeamMutation', team)
        }
      }
    })
  },
  // 查询群成员信息
  async getTeamMembers ({ state, commit }, teamId) {
    return new Promise((resolve, reject) => {
      const nim = state.nim
      nim.getTeamMembers({
        teamId: teamId,
        done: (err, data) => {
          console.log('群成员', data)
          console.log('获取群成员' + (!err ? '成功' : '失败'))
          if (err) {
            resolve([])
          } else {
            resolve(data.members)
          }
        }
      })
    })

  },
  // 查询指定群组成员信息
  getTeamMemberByTeamIdAndAccount ({ state, commit }, { teamId, account }) {
    const nim = state.nim
    nim.getTeamMemberByTeamIdAndAccount({
      teamId: teamId,
      account: account,
      done: (error, obj) => {}
    })
  },
  addTeamMembers ({ state, commit }, { teamId, accounts }) {
    const nim = state.nim
    nim.addTeamMembers({
      teamId: teamId,
      accounts: accounts,
      done: (error, obj) => {
        console.log('入群邀请发送' + (!error?'成功':'失败'), error, obj)
      }
    })
  },
  removeTeamMembers ({ state, commit }, { teamId, accounts }) {
    const nim = state.nim
    nim.removeTeamMembers({
      teamId: teamId,
      accounts: accounts,
      done: (error, obj) => {
        console.log('踢人出群' + (!error?'成功':'失败'), error, obj)
      }
    })
  },
  leaveTeam ({ state, commit, dispatch }, { teamId }) {
    const nim = state.nim
    nim.leaveTeam({
      teamId: teamId,
      done: (error, obj) => {
        console.log('主动退群' + (!error?'成功':'失败'), error, obj)
        if (!error) {
          // dispatch('handleLeaveTeam', { teamId: teamId, teamDismissed: true })
        }
      }
    })
  },
  handleLeaveTeam ({ state, commit, dispatch }, { teamId, teamDismissed }) {
    console.log('teamId', teamId, teamDismissed)
    const nim = state.nim
    const sessionId = `team-${teamId}`
    nim.resetCurrSession(sessionId)
    dispatch('changeImActiveAccountAction', {})
    const newMap = state.imSessionMap
    delete newMap[sessionId]
    commit('refreshImSessionMapMutation', newMap)

    const sessions = state.imSessions.filter(session => session.id !== sessionId)
    commit('setImOrderSessionsMutation', sessions)

    commit('removeImTeamMutation', teamId)
    const teams = state.imTeamsArr.filter(team => team.teamId !== teamId)
    commit('setImTeamArrMutation', teams)

    if (teamDismissed) {
      dispatch('deleteLocalSession', sessionId)
    }
  },
  imConfirm ({ commit }, message) {
    return new Promise((resolve, reject) => {
      commit('SHOW_IM_CONFIRM', { message, resolve, reject })
    })
  },
  imConfirmResolve ({ state, commit }) {
    if (state.imConfirm.resolve) {
      state.imConfirm.resolve()
    }
    commit('HIDE_CONFIRM')
  },
  imConfirmReject ({ state, commit }) {
    if (state.imConfirm.reject) {
      state.imConfirm.reject()
    }
    commit('HIDE_CONFIRM')
  },
  // 设置用户头像：先使用 previewFile 上传头像，然后将 avatar 设置为用户头像
  setMyAvatar ({ state, commit, dispatch }, { done }) {
    const nim = state.nim
    nim.previewFile({
      type: 'image',
      fileInput: 'avatarInput',
      done: done
    })
  },
  // 更新当前im账号资料
  updateMyInfo ({ state, commit }, { userInfo, done }) {
    const nim = state.nim
    nim.updateMyInfo({
      ...userInfo,
      done: done
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/nimActions.js